module.exports = __webpack_public_path__ + "static/media/btt-logo-dark.41f399fe.svg";